export default __webpack_public_path__ + "static/paymentlink2-2ced0bfbdfa30ba464264c4577dc945f.png";